import { render, staticRenderFns } from "./index.vue?vue&type=template&id=382eeda3&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=382eeda3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382eeda3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('382eeda3')) {
      api.createRecord('382eeda3', component.options)
    } else {
      api.reload('382eeda3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=382eeda3&scoped=true&", function () {
      api.rerender('382eeda3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recoveryUp/index.vue"
export default component.exports